var _a, _b;
export const NODE_ENV = (_a = process.env.NODE_ENV) !== null && _a !== void 0 ? _a : 'development';
export const CLOUD_CONVERT_API_KEY = (_b = process.env.CLOUD_CONVERT_API_KEY) !== null && _b !== void 0 ? _b : '';
